import React from 'react';

import { ProfessionalSearchInput } from '@search/vtbeco-frontend-core/domain/offer/search/page/SearchOffersQuery/__generated__/SearchOffersQuery.graphql';
import { SaveSearchModal } from './components/SaveSearchModal';
import { ConfirmEmailModal } from './components/ConfirmEmailModal';
import { SaveSearchSuccessModal } from './components/SaveSearchSuccessModal';
import { SubscriptionSuccessModal } from './components/SubscriptionSuccessModal';
import { useSaveSearch } from './useSaveSearch';
import { SavedSearchLimitModal } from './components/SavedSearchLimitModal';

type Props = {
    searchTitle: string;
    handleClose: () => void;
    openSaveSearch: () => void;
    gqlFilters: ProfessionalSearchInput;
    isMobile?: boolean;
}

export const SaveSearch = ({
    searchTitle: searchTitleInitial,
    handleClose,
    openSaveSearch,
    gqlFilters,
    isMobile
}: Props) => {
    const {
        modalName,
        searchEmail,
        searchTitle,
        setSearchEmail,
        setSearchTitle,
        saveSearch,
        otpSessionData,
        confirmEmail,
        resetEmail,
        verifyEmail,
        isProfessional,
        saveSearchForMeAndCustomers,
    } = useSaveSearch({
        filters: gqlFilters,
        headerTitle: searchTitleInitial,
        handleClose,
        openSaveSearch
    });

    switch (modalName) {
        case 'saveSearch': {
            return (
                <SaveSearchModal
                    onClose={handleClose}
                    searchEmail={searchEmail}
                    searchTitle={searchTitle}
                    setSearchEmail={setSearchEmail}
                    setSearchTitle={setSearchTitle}
                    handleOnSubmit={saveSearch}
                    confirmEmail={confirmEmail}
                    isMobile={isMobile}
                    isProfessional={isProfessional}
                    handleOnSubmitWithCustomers={(p) => {
                        saveSearchForMeAndCustomers(p.forMe, p.forCustomers);
                    }}
                />
            );
        }
        case 'confirmEmail': {
            return (
                <ConfirmEmailModal
                    onClose={handleClose}
                    email={searchEmail}
                    otpSession={otpSessionData}
                    onResetEmail={resetEmail}
                    verifyEmail={verifyEmail}
                />
            );
        }
        case 'saveSearchSuccess': {
            return (
                <SaveSearchSuccessModal
                    isMobile={isMobile}
                    onClose={handleClose}
                />
            );
        }
        case 'subscriptionSuccess': {
            return (
                <SubscriptionSuccessModal
                    isMobile={isMobile}
                    onClose={handleClose}
                    email={searchEmail}
                />
            );
        }
        case 'saveSearchError': {
            return (
                <SavedSearchLimitModal onClose={handleClose} />
            );
        }
        default: {
            return null;
        }
    }
};

